import { createFileRoute } from '@tanstack/react-router';
import { CreditNotesRegister } from '../../../../features/sales-invoicing/CreditNotesRegister';

/** Owned by G23. Credit notes register. */
export const Route = createFileRoute('/_authenticated/sales-invoicing/credit-notes/')({
  component: CreditNotesRegister,
});
